import React, { useEffect, useState } from 'react';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { ClipLoader } from 'react-spinners';
import { customIDs } from '../../utils/customIds';
import moment from 'moment';
import { toast } from 'react-toastify';
import { authAxiosInstance } from '../../utils/axiosConfig';
import TriggerPrinterSelectModal from './TriggerPrinterSelectModal';
import { useDispatch } from 'react-redux';
import { fetchPrinters } from '../../app/reducers/Print/printSlice';

const TriggerAutomation = () => {
    const [loading, setLoading] = useState(false);
    const [showPrinterSelectModal, setShowPrinterSelectModal] = useState(false);
    const [printerDataId, setPrinterDataId] = useState({});
    const [payload, setPayload] = useState(null);

    const dispatch= useDispatch();

    useEffect(()=>{
        dispatch(fetchPrinters());
    },[]);

    const triggerAutomation = async (values) => {
        try {
            const confirm = window.confirm(
                'Are you sure you want to trigger invoice automation'
            );
            if (!confirm) {
                toast.info('Operation canceled');
                return;
            }
            console.log('values', values)
            setLoading(true);
            const resp = await authAxiosInstance.post(
                '/zoho/generate-report',
                values
            );
            console.log(resp.data);
            const automationStatus = resp?.data?.automationStatus;
            if (automationStatus === 'inactive') {
                toast.error('Automation Deactivated', {
                    position: 'top-center',
                    autoClose: false,
                });
                throw new Error('Automation Deactivated');
            }
            const customerLength = parseFloat(resp?.data?.customerLength);
            const startDate = resp?.data?.from
                ? moment(resp.data.from, 'YYYY-MM-DD').format('DD-MM-YYYY')
                : null;
            const endDate = resp?.data?.to
                ? moment(resp.data.to, 'YYYY-MM-DD').format('DD-MM-YYYY')
                : null;

            if (customerLength) {
                const totalHours = parseFloat(
                    (1000 * 60 * 3 * customerLength) / (60 * 60 * 1000)
                ).toFixed(2);
                toast.success(
                    `started generating invoices for ${customerLength} customers, expected time ${totalHours} Hours PO`,
                    { position: 'top-center', autoClose: false }
                );
                toast.success(
                    `PO Start Date :  ${startDate} endDate ${endDate} `,
                    { position: 'top-center', autoClose: false }
                );
            } else {
                toast.warn('customer length not a number');
                toast.success('Invoice Generation started');
            }
        } catch (error) {
            console.log(error);
            toast.error('Error Generating please contact developer');
        } finally {
            setLoading(false);
        }
    };
    return (
        <PageWithCard heading="Trigger Automation">
            <TriggerPrinterSelectModal 
                showPrinterSelectModal={showPrinterSelectModal}
                setShowPrinterSelectModal={setShowPrinterSelectModal}
                printerDataId={printerDataId}
                setPrinterDataId={setPrinterDataId}
                payload={payload}
                triggerAutomation={triggerAutomation}
            />
            {loading ? (
                <ClipLoader />
            ) : (
                <div className="flex flex-col gap-8">
                    <div className="flex gap-3">
                        <div className="flex flex-col gap-2">
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body = {
                                        brokerage: 3,
                                        start: '01-01',
                                        startYear: 'current',

                                        to: '31-03',
                                        endYear: 'current',

                                        oldCredit: 'cf_credit_score_fy_q3',
                                        newCredit: customIDs.credit_q4,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                Jan To March Customer (3) Current Year
                            </PrimaryButton>
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body = {
                                        brokerage: 'x',
                                        start: '01-01',
                                        startYear: 'current',

                                        to: '31-03',
                                        endYear: 'current',

                                        oldCredit: 'cf_credit_score_fy_q3',
                                        newCredit: customIDs.credit_q4,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                X (Testing) Current Year
                            </PrimaryButton>
                        </div>
                        <div className="flex flex-col gap-2">
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body ={
                                        brokerage: 6,
                                        start: '01-10',
                                        startYear: 'previous',

                                        to: '31-03',
                                        endYear: 'current',

                                        oldCredit: 'cf_credit_score_fy_q2',
                                        newCredit: customIDs.credit_q4,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                October To March Customer (6) Previous - Current Year
                            </PrimaryButton>
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body={
                                        brokerage: 'y',
                                        start: '01-10',
                                        startYear: 'previous',

                                        to: '31-03',
                                        endYear: 'current',

                                        oldCredit: 'cf_credit_score_fy_q2',
                                        newCredit: customIDs.credit_q4,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                Y (Testing) Previous - Current Year
                            </PrimaryButton>
                        </div>
                        <div className="flex flex-col gap-2">
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body={
                                        brokerage: 12,
                                        start: '01-04',
                                        startYear: 'previous',

                                        to: '31-03',
                                        endYear: 'current',

                                        oldCredit: 'cf_q1',
                                        newCredit: customIDs.credit_q1,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                April To March Customer (12) Previous - Current Year
                            </PrimaryButton>
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body={
                                        brokerage: 'z',
                                        start: '01-04',
                                        startYear: 'previous',

                                        to: '31-03',
                                        endYear: 'current',

                                        oldCredit: 'cf_q1',
                                        newCredit: customIDs.credit_q1,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                Z (Testing) Previous - Current Year
                            </PrimaryButton>
                        </div>
                    </div>
                    <div className="flex gap-3">
                        <div className="flex flex-col gap-3">
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body = {
                                        brokerage: 3,
                                        start: '01-04',
                                        startYear: 'current',

                                        to: '30-06',
                                        endYear: 'current',

                                        oldCredit: 'cf_credit_score_fy_q4',
                                        newCredit: customIDs.credit_q1,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                April To June Customer (3) Current Year
                            </PrimaryButton>
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body ={
                                        brokerage: 'x',
                                        start: '01-04',
                                        startYear: 'current',

                                        to: '30-06',
                                        endYear: 'current',

                                        oldCredit: 'cf_credit_score_fy_q4',
                                        newCredit: customIDs.credit_q1,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                X (Testing) Current Year
                            </PrimaryButton>
                        </div>
                    </div>
                    <div className="flex gap-3">
                        <div className="flex flex-col gap-3">
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body={
                                        brokerage: 3,
                                        start: '01-07',
                                        startYear: 'current',

                                        to: '30-09',
                                        endYear: 'current',

                                        oldCredit: 'cf_q1',
                                        newCredit: customIDs.credit_q2,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                July to September Customer (3) Current Year
                            </PrimaryButton>
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body={
                                        brokerage: 'x',
                                        start: '01-07',
                                        startYear: 'current',

                                        to: '30-09',
                                        endYear: 'current',

                                        oldCredit: 'cf_q1',
                                        newCredit: customIDs.credit_q2,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                X (Testing) Current Year
                            </PrimaryButton>
                        </div>
                        <div className="flex flex-col gap-3">
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body={
                                        brokerage: 6,
                                        start: '01-04',
                                        startYear: 'current',

                                        to: '30-09',
                                        endYear: 'current',

                                        oldCredit: 'cf_credit_score_fy_q4',
                                        newCredit: customIDs.credit_q2,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                April To September Customer(6) Current Year
                            </PrimaryButton>
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body ={
                                        brokerage: 'y',
                                        start: '01-04',
                                        startYear: 'current',

                                        to: '30-09',
                                        endYear: 'current',

                                        oldCredit: 'cf_credit_score_fy_q4',
                                        newCredit: customIDs.credit_q2,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                Y (Testing) Current Year
                            </PrimaryButton>
                        </div>
                    </div>
                    <div className="flex gap-3">
                        <div className="flex flex-col gap-3">
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body ={
                                        brokerage: 3,
                                        start: '01-10',
                                        startYear: 'previous',

                                        to: '31-12',
                                        endYear: 'previous',

                                        oldCredit: 'cf_credit_score_fy_q2',
                                        newCredit: customIDs.credit_q3,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                October To December Customer (3) Previous Year
                            </PrimaryButton>
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const body={
                                        brokerage: 'x',
                                        start: '01-10',
                                        startYear: 'previous',

                                        to: '31-12',
                                        endYear: 'previous',

                                        oldCredit: 'cf_credit_score_fy_q2',
                                        newCredit: customIDs.credit_q3,
                                        group_a_date: moment().format('DD-MM'),
                                        group_b_date: moment().format('DD-MM'),
                                        invoiceYear: 'current',
                                        // printerId: 72705643,
                                    }
                                    // triggerAutomation();
                                    setPayload(body)
                                    setShowPrinterSelectModal(true)
                                }}
                            >
                                X (Testing) Previous Year
                            </PrimaryButton>
                        </div>
                    </div>
                </div>
            )}
        </PageWithCard>
    );
};

export default TriggerAutomation;
